import { c as _c } from "react/compiler-runtime";
import { GroupDescriptionType } from "@/entities/IGroup";
import { GroupCardConfigProps } from "./GroupCardConfigs";
export default function GroupCardConfig(t0) {
  const $ = _c(8);
  const {
    config
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [GroupDescriptionType.TDH]: "Tdh",
      [GroupDescriptionType.REP]: "Rep",
      [GroupDescriptionType.NIC]: "NIC",
      [GroupDescriptionType.LEVEL]: "Level",
      [GroupDescriptionType.OWNS_NFTS]: "Owns NFTs",
      [GroupDescriptionType.WALLETS]: "Identities"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const configLabel = t1;
  const t2 = configLabel[config.key];
  let t3;
  if ($[1] !== t2) {
    t3 = <span>{t2}:</span>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== config.value) {
    t4 = <span className="tw-font-semibold">{config.value}</span>;
    $[3] = config.value;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <div className="tw-whitespace-nowrap tw-cursor-default tw-inline-flex tw-items-center tw-gap-x-1 tw-justify-between tw-shadow-sm tw-rounded-lg tw-px-2 tw-py-1.5 tw-text-sm tw-font-normal tw-text-iron-300 tw-bg-iron-700 tw-ring-1 tw-ring-inset tw-ring-iron-700">{t3}{t4}</div>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}